import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getAllTaahodatSalesMali = createAsyncThunk('TaahodSalesMali/GetAllTaahodatSalesMali', async () => {
  return await KhodroHttpGetService({
    url: `${_apiPathManagerConfig?.Khodro.TaahodSalesMali.GetAllTaahodatSalesMali}`,
  });
});
